webpackJsonp([35783957827783],{

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.hoistNonReactStatics = factory());
	}(this, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));


/***/ }),

/***/ 251:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(52);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _classnames = __webpack_require__(268);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Button = function Button(_ref) {
	  var children = _ref.children,
	      primary = _ref.primary,
	      onClick = _ref.onClick,
	      href = _ref.href,
	      disabled = _ref.disabled,
	      rest = _objectWithoutProperties(_ref, ['children', 'primary', 'onClick', 'href', 'disabled']);
	
	  var classes = (0, _classnames2.default)('btn', { primary: primary });
	  if (!href || disabled) return _react2.default.createElement(
	    'button',
	    _extends({
	      className: classes,
	      onClick: onClick,
	      disabled: disabled
	    }, rest),
	    children
	  );
	  return _react2.default.createElement(
	    'a',
	    _extends({ className: classes, href: href }, rest),
	    children
	  );
	};
	
	exports.default = Button;
	module.exports = exports['default'];

/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(52);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Button = __webpack_require__(251);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var handleClick = function handleClick(text) {
	  return function (e) {
	    e.preventDefault();
	    alert(text);
	  };
	};
	
	var IndexPageCurrent = function IndexPageCurrent() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'section',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'We are a team of ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          'social'
	        ),
	        ' and',
	        ' ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          'experienced'
	        ),
	        ' software engineers in',
	        ' ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Prague'
	        ),
	        '. We work with you as a cross-functional team to craft software with amazing tech, customer experience and pragmatism.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Our team has many years experience in both developing and managing highly scalable and available apps and websites. Experience in working with startup as well as enterprise environments. We also love to talk tech so feel free to stop by and say "hello".'
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'right' },
	      _react2.default.createElement(
	        _Button2.default,
	        { primary: true, href: 'mailto:roman@shedlabs.tech' },
	        'Say Hello'
	      ),
	      ' '
	    )
	  );
	};
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'section',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'We are a team of ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          'social'
	        ),
	        ' and',
	        ' ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          'experienced'
	        ),
	        ' software engineers in',
	        ' ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Prague'
	        ),
	        '. We work with you as a cross-functional team to craft software with amazing tech, customer experience and pragmatism.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Our team has many years experience in both developing and managing highly scalable and available apps and websites. Experience in working with startup as well as enterprise environments. We also love to talk tech so feel free to stop by and say "hello".'
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'flipped' },
	      _react2.default.createElement(
	        'h2',
	        null,
	        'We can help you'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'Validate & realise new ideas'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Deliver quality products & services fast'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Be bold with technology'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Be more customer centric'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Improve efficiency with lean practices'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Deliver "just in time" UX'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      null,
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Our 5 principles'
	      ),
	      _react2.default.createElement(
	        'ol',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'People people'
	          ),
	          _react2.default.createElement('br', null),
	          'Our work is built on the respect we have for each other and our clients. We\u2019re also very focused on the needs of our clients\u2019 customers.'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Find a way'
	          ),
	          _react2.default.createElement('br', null),
	          'As individuals we need to be proactive and to earn and build the trust of our clients.'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Always learning'
	          ),
	          _react2.default.createElement('br', null),
	          'We\u2019re curious. It\u2019s how we learn and grow as individuals, continuously testing and improving what we do, and how we do it.'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Honest'
	          ),
	          _react2.default.createElement('br', null),
	          'We\u2019re relied upon to tell things as they are. We do so in an approachable and down-to-earth manner.'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Strong opinions, weakly held'
	          ),
	          _react2.default.createElement('br', null),
	          'Clear points-of-view help give our work direction and purpose \u2013 but we\u2019re humble about these. We don\u2019t let ego get in the way.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'right' },
	      _react2.default.createElement(
	        _Button2.default,
	        { primary: true, href: 'mailto:roman@shedlabs.tech' },
	        'Say Hello'
	      ),
	      ' '
	    ),
	    _react2.default.createElement(
	      'section',
	      null,
	      _react2.default.createElement(
	        'h2',
	        null,
	        'More about us'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'flex' },
	        _react2.default.createElement(
	          'div',
	          { className: 'box' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Experienced.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Our engineers are experienced. We are polyglots across many languages and disciplines. We thrive on the challenging and complicated applying our experience across many sectors.'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'box' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Agile.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'We are serious about agile. We have a deep understanding and have delivered a plethora of projects using Kanban and SCRUM. We love eliminating waste to ship on time and within budget.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'flex' },
	        _react2.default.createElement(
	          'div',
	          { className: 'box' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Transparent.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'We work openly and honestly together as one team. Whether it be our place or yours. Our pricing model is simple and predictable.'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'box' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Open Source.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Everyone of us loves open source tech and embraces it. In the end, we get a lot of stuff for free, right? :)'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = IndexPageCurrent;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-1ecab302e4e9cee313dc.js